export const app = {
    APP_PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
    API_BASE_URL: process.env.REACT_APP_API_URL,
    ENVIRONMENT: process.env.REACT_APP_ENVIRONEMNT
}